(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xelano-installment-terms-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialogId = 'xelano-installment-terms-dialog';
    const dialogHash = `#${dialogId}`;
    const dialog = document.getElementById(dialogId);
    if (!dialog) return;

    let lastTrigger = null;

    const openDialog = (trigger) => {
      lastTrigger = trigger || document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.body.classList.add('xelano-terms-dialog-open');
    };

    const closeDialog = () => {
      if (dialog.open) dialog.close();
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest(`a[href="${dialogHash}"]`);
      if (trigger) {
        event.preventDefault();
        openDialog(trigger);
        return;
      }

      if (event.target.closest('[data-installment-terms-close]')) closeDialog();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('close', () => {
      document.body.classList.remove('xelano-terms-dialog-open');
      if (lastTrigger instanceof HTMLElement) lastTrigger.focus();
    });

    if (window.location.hash === dialogHash) openDialog();
  })();
  } catch(e) { console.error(e); }
})();

})();
